import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import Select from "../../form/Select";
import OptInSubscriberFilter from "./NewsLetter/OptInSubscriberFilter";
import UserFilter from "./NewsLetter/UserFilter";
import isEqual from "lodash-es/isEqual";
import {sendRequest} from "../../../utils/request";
import parseQuery from "./NewsLetter/QueryBuilder/parseQuery";
import unparseQuery from "./NewsLetter/QueryBuilder/unparseQuery";
import removeEmpty from "./NewsLetter/QueryBuilder/removeEmpty";
import FileLister from "./NewsLetter/FileLister";

class NewsletterTargetForm extends React.Component {

    parseValue = (filter) => {
        if (typeof filter === "string") {
            try {
                return JSON.parse(filter);
            } catch (e) {

            }
        }
        return filter;
    }

    render() {
        const filterProps = {
            componentConfig: this.props.componentConfig,
            dirty: this.props.dirty,
            values: this.props.values,
            importFile: this.props.importFile,
            name: "filter",
            value: this.parseValue(this.props.values.filter),
            saveChanges: this.props.setFieldValue
        };
        let FilterComponent = null;
        switch (this.props.values.component) {
            case "OptInSubscriber":
                FilterComponent = OptInSubscriberFilter;
                break;
            case "user":
                FilterComponent = UserFilter;
                break;
            case "":
                FilterComponent = FileLister;
                break;
        }
        const disabled = this.props.newsletterDisabled;
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput
                            name={this.props.componentConfig.idfield}
                            value={this.props.values[this.props.componentConfig.idfield]}
                            label="Kód"
                            role="idfield"
                            {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                        />
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <Select
                            name="component"
                            storeType="local"
                            valueKey="key"
                            labelKey="label"
                            value={this.props.values.component}
                            saveChanges={this.props.setFieldValue}
                            autoSelect={true}
                            objectValue={false}
                            options={[
                                {key: "", label: "Lista fájl"},
                                {key: "user", label: "Felhasználók"},
                                {key: "OptInSubscriber", label: "OptIn Feliratkozottak"},
                            ]}
                            label="Típus"
                            disabled={disabled || this.props.isLoading}
                        />
                    </div>
                </div>
                {FilterComponent && <Fragment>
                    <FilterComponent
                        {...filterProps}
                        disabled={disabled || this.props.isLoading}
                        component={this.props.componentConfig.componentname}
                    />
                </Fragment>}
            </form>
        );
    }
}

export default createForm(NewsletterTargetForm);
